<template>
    <div>
        <b-container fluid class="mt--7 pb-4">
            <b-row>
                <b-col>
                    <b-overlay :show="showOverlay" rounded="sm">
                        <b-card>
                            <b-card-header>
                                <b-row class="align-items-center">
                                    <b-col class="col-6">
                                        <h3 v-if="isNew">New Order</h3>
                                        <h3 class="mb-0" v-else>
                                            {{ orderType.name }} &nbsp;
                                            <small>
                                                <b-badge
                                                    :variant="
                                                        orderModel
                                                            | filterStatusVariant
                                                    "
                                                    >{{
                                                        orderModel
                                                            | filterStatusName
                                                    }}</b-badge
                                                ></small
                                            >
                                        </h3>
                                    </b-col>
                                    <b-col class="text-right" v-if="!isNew">
                                        <b-button
                                            to="/admin/orders/0"
                                            variant="success"
                                        >
                                            New Order
                                        </b-button>
                                        <b-button
                                            @click="toggleCompletion()"
                                            :disabled="updating"
                                            >{{
                                                orderModel.completed
                                                    ? 'Mark as Incomplete'
                                                    : 'Mark as Complete'
                                            }}</b-button
                                        >

                                        <b-button
                                            @click="deleteOrder()"
                                            variant="warning"
                                        >
                                            Delete Order
                                        </b-button>
                                    </b-col>
                                </b-row>
                            </b-card-header>

                            <b-tabs card v-model="tabIdx" :fill="isNew">
                                <b-tab :title="isNew ? '' : 'Summary'">
                                    <b-card-body>
                                        <view-order-summary
                                            ref="orderSummary"
                                            :prop-data="orderModel"
                                            :view-mode="viewMode"
                                            :updating="updating"
                                            :is-new="isNew"
                                            @change-mode="viewMode = $event"
                                            @save-order="updateOrder"
                                            @sync-order="syncOrder"
                                        />
                                    </b-card-body>
                                </b-tab>

                                <b-tab title="Location" v-if="!isNew">
                                    <b-card-body>
                                        <location-section
                                            ref="locationSection"
                                            v-model="
                                                orderModel.delivery_location_section_id
                                            "
                                            :hide-controls="false"
                                            title="Delivery Location"
                                            :save-label="orderSaveLabel"
                                            @trigger-location-save="updateOrder"
                                            @update-section-model="
                                                updateSectionEvent
                                            "
                                        ></location-section>
                                    </b-card-body>
                                </b-tab>

                                <b-tab title="Items" v-if="!isNew">
                                    <b-card-body>
                                        <view-order-items
                                            ref="orderItems"
                                            :view-mode="viewMode"
                                            @change-mode="viewMode = $event"
                                        />
                                    </b-card-body>
                                </b-tab>

                                <b-tab title="Messages" v-if="!isNew">
                                    <b-card-body>
                                        <view-notes :order="order" />
                                    </b-card-body>
                                </b-tab>

                                <b-tab title="Attachments" v-if="!isNew">
                                    <b-card-body>
                                        <view-attachments
                                            :order="
                                                preparedOrderWithAttachments
                                            "
                                        />
                                    </b-card-body>
                                </b-tab>

                                <b-tab title="Released By" v-if="!isNew">
                                    <b-card-body>
                                        <view-released-by :order="order" />
                                    </b-card-body>
                                </b-tab>

                                <b-tab title="Received By" v-if="!isNew">
                                    <b-card-body>
                                        <view-received-by :order="order" />
                                    </b-card-body>
                                </b-tab>

                                <b-tab
                                    title="Reviews"
                                    v-if="!isNew"
                                    @click="reviewTabActivated = true"
                                >
                                    <b-card-body>
                                        <view-checkoffs
                                            v-if="reviewTabActivated"
                                        ></view-checkoffs>
                                    </b-card-body>
                                </b-tab>
                            </b-tabs>
                        </b-card>
                    </b-overlay>
                </b-col>
            </b-row>
            <b-modal
                hide-footer
                title="Create Order template from Order"
                id="order-template-modal"
            >
                <create-template-from-order v-model="orderModel.newTemplate" />

                <b-row>
                    <b-col>
                        <b-button
                            class="mt-2"
                            variant="secondary"
                            block
                            @click="$bvModal.hide('order-template-modal')"
                            >Cancel</b-button
                        >
                    </b-col>
                    <b-col>
                        <b-button
                            class="mt-2"
                            variant="primary"
                            block
                            @click="createTemplate"
                            >Create Template</b-button
                        >
                    </b-col></b-row
                ></b-modal
            >
        </b-container>
    </div>
</template>
<script>
import CreateTemplateFromOrder from '@/components/CreateTemplateFromOrder.vue'
import ViewOrderItems from './ViewOrderItems.vue'
import ViewNotes from './ViewNotes.vue'
import ViewAttachments from './ViewAttachments.vue'
import ViewReceivedBy from './ViewReceivedBy.vue'
import ViewReleasedBy from './ViewReleasedBy.vue'
import LocationSection from '@/views/Location/LocationSection'
import ViewOrderSummary from './ViewOrderSummary'
import ViewCheckoffs from './ViewCheckoffs.vue'
//mixins
import orderHelperMixins from '@/mixins/orderHelperMixins'
import popupMixins from '@/mixins/popupMixins'
import utilityMixins from '@/mixins/utilityMixins'
import locationMixins from '@/mixins/locationMixins'

const L = window.L
export default {
    name: 'view-order',
    components: {
        CreateTemplateFromOrder,
        ViewOrderItems,
        ViewNotes,
        LocationSection,
        ViewAttachments,
        ViewReceivedBy,
        ViewReleasedBy,
        ViewOrderSummary,
        ViewCheckoffs,
    },
    mixins: [orderHelperMixins, popupMixins, locationMixins, utilityMixins],
    data() {
        return {
            tabIdx: 0,
            reviewTabActivated: false,
            viewMode: true,
            orderModel: {
                /* other props go gere */
                notes: [
                    {
                        content: 'Simple item task...',
                    },
                ],
                delivery_location_section_id: null,
            },

            updating: false,
        }
    },
    filters: {
        capitalize: function (value) {
            if (!value) return ''
            value = value.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        },
        filterStatusName(item) {
            return item.completed
                ? 'Completed'
                : item.warehouse_signed
                ? 'Processing'
                : 'Pending'
        },

        filterStatusVariant(item) {
            return item.completed
                ? 'success'
                : item.warehouse_signed
                ? 'primary'
                : 'danger'
        },
    },

    computed: {
        showOverlay() {
            return this.$store.state.orders.orderLoadingState
        },
        isNew() {
            const id = this.$route.params.id
            console.log('isNew Id', id)
            return (id || 0) == 0
        },
        orderSaveLabel() {
            return this.updating ? 'Updating Order' : 'Update Order'
        },
        order() {
            const item = this.$store.state.orders.item
            console.log('computed---order', item)
            return { ...(item || {}) }
        },
        drivers() {
            return this.$store.state.orders.drivers
        },
        warehouses() {
            return this.$store.state.orders.warehouses
        },

        preparedOrderWithAttachments() {
            const x_order = { ...this.order }
            if (!Array.isArray(x_order.attachments)) {
                x_order.attachments = []
            }
            return x_order
        },

        customerName() {
            return this.order && this.order.customer && this.order.customer.name
        },

        orderId() {
            return this.$route.params.id
        },
        orderTypes() {
            const orderTypes = this.$store.state.orderType.items
            console.log('orderTypes', orderTypes)
            return orderTypes
        },
        orderType() {
            return (
                this.orderTypes.find(x => x.id === this.order.order_type_id) ||
                {}
            )
        },
    },

    watch: {
        tabIdx: function (val) {
            console.log('tabIdx', val)
        },
        order: {
            handler: function (val) {
                console.log('watching order')
                console.log('watch----- order', val)
                for (const key in val) {
                    switch (key) {
                        case 'schedule_at': {
                            const { date, time } = this.getScheduleAtParts(
                                val.schedule_at
                            )
                            this.orderModel.date = date
                            this.orderModel.time = time
                            break
                        }
                        case 'location':
                            this.orderModel.location = new L.latLng(
                                val.lat ? val.lat : 0,
                                val.long ? val.long : 0
                            )
                            break
                        case 'completed': {
                            this.orderModel.completed = !!val.completed
                            break
                        }
                        default: {
                            if (this.orderModel[key] !== val[key]) {
                                this.orderModel[key] = val[key]
                            }
                        }
                    }
                }
                console.log('watch-----order--this.orderModel', this.orderModel)
            },
            deep: true,
        },
    },
    created() {
        this.$store.dispatch('orderType/fetchAll')
        this.$store.dispatch('orders/fetchDrivers')
        this.$store.dispatch('orders/fetchWarehouses')
        const id = this.$route.params.id
        console.log('route.params.id', id)
        id && this.$store.dispatch('orders/fetchById', id)
    },

    methods: {
        syncOrder(data) {
            this.orderModel = { ...this.orderModel, ...data }
        },
        async updateOrder() {
            try {
                console.log('updateOrder this.orderModel', this.orderModel)

                let model = (({
                    customer_id,
                    reference_no,
                    driver_id,
                    description,
                    delivery_location_section_id,
                    date,
                    time,
                    signature,
                    newTemplate,
                }) => ({
                    customer_id,
                    reference_no,
                    driver_id,
                    description,
                    delivery_location_section_id,
                    schedule_at: this.getScheduleAt(date, time),
                    signature,
                    newTemplate,
                }))({
                    ...this.orderModel,
                })

                model = { ...model, ...(this.sectionLocationEventData || {}) }
                this.updating = true

                model.id = this.$route.params.id
                if (model.newTemplate) {
                    await this.$store.dispatch(
                        'orderTemplate/create',
                        model.newTemplate
                    )
                }
                await this.$store.dispatch('orders/update', model)

                this.doToast('Order Updated!', 'Your Order Updated.', 'success')
                this.viewMode = true
            } catch (error) {
                console.error('update', error)
                this.doToast('Error!', 'Error Updating Order!', 'danger')
            } finally {
                this.updating = false
            }
        },
        currency(num) {
            num = parseFloat(num)
            console.log('num.......', num)
            try {
                return num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
            } catch (err) {
                return '0.00'
            }
        },
        toggleCompletion() {
            if (this.orderModel.completed) {
                this.markAsIncomplete()
            } else {
                this.markAsComplete()
            }
        },
        markAsComplete() {
            const title = 'Mark as Complete?'
            const message = `Are you sure you want to mark this order as complete?`
            this.confirmMessage(title, message).then(result => {
                if (!result) return
                this.updating = true
                this.$store
                    .dispatch('orders/markAsComplete', this.$route.params.id)
                    .then(() => {
                        this.doToast(
                            'Order Completed!',
                            'Order Completed!',
                            'success'
                        )
                    })
                    .catch(error => {
                        console.error('mark as complete', error)
                        this.doToast(
                            'Error Marking as Complete!',
                            'Unable to Mark as Completed!',
                            'danger'
                        )
                    })
                    .finally(() => {
                        this.updating = false
                    })
            })
        },
        async createTemplate() {
            try {
                const template = {
                    order_category_id:
                        this.orderModel.newTemplate.order_category_id,
                    name: this.orderModel.newTemplate.order_template_name,
                    description: this.orderModel.description,
                }
                const { id } = this.order
                const data = await this.$store.dispatch(
                    'orders/createTemplate',
                    {
                        id,
                        template,
                    }
                )
                this.$bvModal.hide('order-template-modal')
                this.doToast(
                    'Success',
                    'Order template successfully created',
                    'success'
                )
                console.log(data)
            } catch (err) {
                const responseMessage = err.response.data.error.message
                let errorMessage = 'Unable to create order template. '
                console.log(err.response.data.error)

                // Check if the fields have not been set
                if (responseMessage.includes('cannot be null')) {
                    errorMessage +=
                        'Please set a name and select an order category for your template'

                    // Checks if the order template already exists
                } else if (responseMessage.includes('Duplicate entry')) {
                    errorMessage +=
                        'Name of Order template already exists. Please select a new name'
                } else {
                    errorMessage += responseMessage
                }

                this.doToast('Error', errorMessage, 'danger')
            }
        },
        markAsIncomplete() {
            const title = 'Mark as Incomplete?'
            const message = `Are you sure you want to mark this order as incomplete?`
            this.confirmMessage(title, message).then(result => {
                if (!result) return

                this.updating = true
                this.$store
                    .dispatch('orders/markAsIncomplete', this.$route.params.id)
                    .then(() => {
                        this.doToast(
                            'Order Set As Incomplete!',
                            'Order Set As Incomplete!',
                            'success'
                        )
                        //this.orderModel.complete = false
                    })
                    .catch(error => {
                        console.error('markAsIncomplete', error)
                        this.doToast(
                            'Error Marking as Incomplete!',
                            'Error Marking as Incomplete!',
                            'danger'
                        )
                    })
                    .finally(() => {
                        this.updating = false
                    })
            })
        },

        deleteOrder() {
            // Initializing key variables
            let model = { ...this.orderModel }
            model.name = 'Order'
            const routes = {
                baseRoute: '/orders',
                deleteRoute: 'orders/delete',
            }
            const notificationFields = {
                type: 'Order',
                errorMsg: 'Unable to delete order',
            }

            this.deleteItem(notificationFields, model, routes)
        },
    },
}
</script>
